////////////////////////////////////////////////////////////////////////////////
// viem/chains
////////////////////////////////////////////////////////////////////////////////
// biome-ignore lint/performance/noBarrelFile: entrypoint module
// biome-ignore lint/performance/noReExportAll: entrypoint module
export * from 'viem/chains';
//# sourceMappingURL=chains.js.map